var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgNophoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 172 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1664_135132)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 172,
    height: 233,
    rx: 8,
    fill: "#EFF2F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1664_135132",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: 0,
    width: 179,
    height: 179
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.371 152.468C183.05 117.79 183.05 61.5657 148.371 26.8875C113.693 -7.79072 57.4687 -7.79073 22.7905 26.8875C-11.8877 61.5657 -11.8877 117.79 22.7905 152.468C57.4687 187.147 113.693 187.147 148.371 152.468Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1664_135132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.5 167.8C145.5 187.9 26 187.9 26 167.8C26 147.7 73.2 139.8 85.7 139.8C98.3 139.9 145.5 147.7 145.5 167.8Z",
    fill: "#0077B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7 128.8C70.1 128.8 57.5 116.2 57.5 100.6V78.2C57.5 62.6 70.1 50 85.7 50C101.3 50 113.9 62.6 113.9 78.2V100.6C113.9 116.2 101.3 128.8 85.7 128.8Z",
    fill: "#008BC7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1664_135132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172,
    height: 233,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgNophoto);
export default __webpack_public_path__ + "static/media/img-nophoto.1e8a76e9ba27e8ceed02e5b9b72c6f13.svg";
export { ForwardRef as ReactComponent };